import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Field } from 'redux-form';
import Typography from '@mui/material/Typography';
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import NativeSelect from '@mui/material/NativeSelect';
import olympiadService from '../../../../../services/olympiad.service';
import { validateRequiredSelect } from '../validate';

const renderTeacherNameField = ({ input, meta: { touched, error }, options, i18n, ...custom }) => {
    const showError = touched && error;
    return (
        <div
            style={{
                borderBottom: showError ? '2px solid red' : '2px solid transparent',
                paddingBottom: 4,
            }}
        >
            <NativeSelect {...input} {...custom}>
                <option value="">{i18n.t('filter.choose_teacher')}</option>
                {options.map(item => (
                    <option key={item.id} value={item.id}>
                        {item.title}
                    </option>
                ))}
            </NativeSelect>
        </div>
    );
};

export default ({ label, code }) => {
    const { i18n } = useTranslation();
    const [options, setOptions] = useState([]);

    useEffect(() => {
        const fetchTeachersName = async () => {
            try {
                const data = await olympiadService.GetTeachersName();
                const TeachersNameOptions = data.map(item => ({
                    id: item.id,
                    title: item.last_name + ' ' + item.first_name,
                }));
                setOptions(TeachersNameOptions);
            } catch (error) {
                console.error(error);
            }
        };
        fetchTeachersName();
    }, []);

    return (
        <Card>
            <CardContent>
                <Typography gutterBottom variant="h6" component="h2">
                    {i18n.t(label)}
                </Typography>
                <Field
                    name={code}
                    i18n={i18n}
                    options={options}
                    component={renderTeacherNameField}
                    type="text"
                    validate={validateRequiredSelect}
                />
            </CardContent>
        </Card>
    );
};
